import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { from } from 'rxjs';

import { AppModule } from './app/app.module';
//import { environment } from './environments/environment';

// Modified by DARSHAN NAGARAJ
// Date:11-03-2026
// Modified the implementation for Externalize Angular API Endpoints for Runtime Configuration

fetch('/assets/config.json')
  .then(response => response.json())
  .then(config => {

    // store config globally
    (window as any).__config = config;

    console.log("Config loaded before Angular bootstrap:", config);
 // Now load environment AFTER config
    const { environment } = require('./environments/environment');

if (environment.production) {
  const isConsolelogEnabled = (environment as any).isConsolelogEnabled ?? true// Default to true if isConsolelogEnabled missing
  if(!isConsolelogEnabled){
      console.log   = () => {};
      console.info  = () => {};
      console.warn  = () => {};
    }
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], }).then(() => {
  if ('serviceWorker' in navigator && environment.production) {
    navigator.serviceWorker.register('/ngsw-worker.js');
  }
}).catch(err => console.log(err));

 })
  .catch(err => {
    console.error("Failed to load config.json", err);
  });